<template>
    <div class="safe-section" v-if="safeArr != null" id="menu-link-safe">
        <div class="container">
            <sectionTitle :options="[{ title : safeArr.safe_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: safeArr.safe_quote_img, title : safeArr.safe_quote_title, desc: safeArr.safe_quote_desc}]"></sectionBaner>
            <div class="number-items" v-if="!isMobileGlobal">
                <div class="item" v-for="(item, index) in safeArr.safe_cards" :key="item.title">
                    <!-- <div class="item-img"><img :src="item.img" alt=""></div> -->
                    <div class="item-num">
                        <span v-if="index < 9">0{{ index + 1 }}</span>
                        <span v-else>{{index + 1}}</span>
                    </div>
                    <div class="item-title"><h4 v-html="item.title"></h4></div>
                    <div class="item-desc"><p v-html="item.desc"></p></div>
                </div>
            </div>
            <div class="number-items number-items-mobile" v-else>
                <div class="item" v-for="(item, index) in safeArr.safe_cards_mobile" :key="item.title">
                    <!-- <div class="item-img"><img :src="item.img" alt=""></div> -->
                    <div class="item-num">
                        <span v-if="index < 9">0{{ index + 1 }}</span>
                        <span v-else>{{index + 1}}</span>
                    </div>
                    <div class="item-title"><h4 v-html="item.title"></h4></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'safe-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            safeArr: 'loadSafeArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/safe/safe-section.scss';
    @import '@/styles/components/safe/safe-section-respond.scss';
</style>